import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CurrentLocaleService {

  constructor(
    private translateService: TranslateService
  ) {
  }

  getCurrentLang() {
    return this.translateService.currentLang || environment.defaultLocale
  }
}
